
  <div class="row mt-4" *ngIf="rolesReady">
      <div class="col-12">
          <form name="reqForm"
                role="form">
                <label class="input-label mb-2">{{message.subject}}</label>
              <div class="row">
                  <div class="col-md-6 col-sm-12">
                      <ng-select [(ngModel)]="selectedRoles"
                                 name="selectedRoles"
                                 bindLabel="text"
                                 bindValue="id"
                                 [readonly]="messageType == 'ALERT'"
                                 [clearable]="false"
                                 [multiple]="true"
                                 [items]="roles"
                                 placeholder="{{ 'Set receiver' | translate }}"></ng-select>
                      <p class="validation-error"
                         *ngIf="!selectedRoles || selectedRoles.length == 0">{{ 'form.validate.required' | translate }}</p>
                  </div>
                  <div class="col-md-6 col-sm-12">
                      <textarea class="form-control"
                                name="additionalInformation"
                                placeholder="{{ 'modal.comment_in_context' | translate }}"
                                [(ngModel)]="roleStatusMessage.additionalInfo"
                                rows="1"></textarea>
                  </div>
              </div>
              <div class="row mt-3">
                  <div class="col-12">
                    <table>
                        <thead class="thead-inverse">
                            <tr>
                                <th class="text-left" colspan="2" style="width: 90%;">
                                  {{'roles.delays' | translate}}
                                </th>
                                <th style="width: 10%;">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let delay of roleStatusMessage.delays; let i = index;">
                                <td colspan="2">{{getDisplayDelay(delay.value)}}</td>
                                <td class="text-right align-middle">
                                    <confirmation [showTrashIcon]="true"
                                                  [question]="'confirm.areyousure'"
                                                  (isConfirmed)="removeDelay($event, i);"
                                                  style="position:relative;top:-1px;">
                                    </confirmation>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                  <div class="input-group input-group-sm">
                                    <input class="form-control"
                                           type="number"
                                           name="delayDays"
                                           [(ngModel)]="valueDays">
                                    <div class="input-group-append">
                                      <span class="input-group-text" id="basic-addon1">{{'roles.days' | translate}}</span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div class="input-group input-group-sm">
                                    <input class="form-control"
                                           type="number"
                                           name="delayHours"
                                           [(ngModel)]="valueHours">
                                    <div class="input-group-append">
                                      <span class="input-group-text" id="basic-addon2">{{'roles.hours' | translate}}</span>
                                    </div>
                                  </div>
                                </td>
                                <td class="align-middle">
                                  <a (click)="addNewDelay()"
                                     class="editBtn btn-dark">{{'Add' | translate }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
              </div>
          </form>
      </div>
  </div>
